var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaSuspense1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.683 112.44C170.683 149.683 142.821 168.305 109.707 179.106C107.973 179.656 106.089 179.629 104.373 179.031C71.1787 168.305 43.3176 149.683 43.3176 112.44V60.2984C43.3176 58.3228 44.1563 56.4282 45.6491 55.0313C47.142 53.6344 49.1667 52.8496 51.2779 52.8496C67.1986 52.8496 87.0993 43.9111 100.95 32.589C102.637 31.2408 104.782 30.5 107 30.5C109.218 30.5 111.364 31.2408 113.05 32.589C126.98 43.9856 146.802 52.8496 162.722 52.8496C164.833 52.8496 166.858 53.6344 168.351 55.0313C169.844 56.4282 170.683 58.3228 170.683 60.2984V112.44Z",
    fill: "url(#paint0_linear_2162_30918)",
    stroke: "url(#paint1_linear_2162_30918)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0001 95.5C100 95.5 105.5 89.5 105 89.5C104.5 89.5 93.5001 89.5 93.0001 89.5C92.5001 89.5 98.0001 95.5 99.0001 95.5Z",
    fill: "#3F2990"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 127.286H117.25M81 75.5H117.25M112.071 127.286V116.483C112.071 115.11 111.525 113.793 110.554 112.822L99.125 101.393M99.125 101.393L87.6959 112.822C86.7247 113.793 86.1789 115.11 86.1786 116.483V127.286M99.125 101.393L87.6959 89.9638C86.7247 88.9928 86.1789 87.6758 86.1786 86.3025V75.5M99.125 101.393L110.554 89.9638C111.525 88.9928 112.071 87.6758 112.071 86.3025V75.5",
    stroke: "#100F11",
    strokeWidth: 5.17857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.834 142.334L123.656 133.157L132.834 142.334Z",
    fill: "#C4FFB3",
    fillOpacity: 0.62
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.834 142.334L123.656 133.157",
    stroke: "#100F11",
    strokeWidth: 4.22917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.745 135.99C120.336 135.99 126.49 129.836 126.49 122.245C126.49 114.654 120.336 108.5 112.745 108.5C105.154 108.5 99.0001 114.654 99.0001 122.245C99.0001 129.836 105.154 135.99 112.745 135.99Z",
    fill: "#C4FFB3",
    fillOpacity: 0.62,
    stroke: "#100F11",
    strokeWidth: 3.4362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0327 202.136V222.5H79.2088L68.858 207.565H68.669V222.5H65.5966V202.136H68.4403L78.8011 217.091H78.9901V202.136H82.0327ZM86.2759 222.5V207.227H89.2489V222.5H86.2759ZM86.5543 205.189L88.881 200.605H92.0131L88.9308 205.189H86.5543ZM106.314 207.227L100.776 222.5H97.5938L92.0455 207.227H95.2372L99.1051 218.98H99.2642L103.122 207.227H106.314ZM115.171 222.808C113.666 222.808 112.37 222.487 111.283 221.844C110.203 221.194 109.367 220.283 108.777 219.109C108.194 217.929 107.902 216.547 107.902 214.963C107.902 213.399 108.194 212.02 108.777 210.827C109.367 209.634 110.189 208.702 111.243 208.033C112.304 207.363 113.543 207.028 114.962 207.028C115.824 207.028 116.659 207.171 117.468 207.456C118.276 207.741 119.002 208.188 119.645 208.798C120.288 209.408 120.795 210.2 121.167 211.175C121.538 212.143 121.723 213.319 121.723 214.705V215.759H109.583V213.531H118.81C118.81 212.749 118.651 212.056 118.333 211.453C118.015 210.843 117.567 210.363 116.99 210.011C116.42 209.66 115.751 209.484 114.982 209.484C114.147 209.484 113.417 209.69 112.794 210.101C112.178 210.505 111.701 211.036 111.363 211.692C111.031 212.341 110.865 213.047 110.865 213.81V215.55C110.865 216.571 111.044 217.439 111.402 218.155C111.767 218.871 112.274 219.418 112.924 219.795C113.573 220.167 114.332 220.352 115.201 220.352C115.764 220.352 116.278 220.273 116.742 220.114C117.206 219.948 117.607 219.703 117.945 219.378C118.283 219.053 118.542 218.652 118.721 218.175L121.534 218.682C121.309 219.51 120.905 220.236 120.321 220.859C119.745 221.476 119.019 221.956 118.144 222.301C117.275 222.639 116.284 222.808 115.171 222.808ZM127.995 202.136V222.5H125.022V202.136H127.995ZM147.091 202.136V222.5H144.009V205.219H143.889L139.017 208.401V205.457L144.098 202.136H147.091Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30918",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A556B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AC3CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30918",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804A01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaSuspense1);
export default __webpack_public_path__ + "static/media/Medalha_suspense_1.d4503f3b19ce050c01b011e1d7c91cc4.svg";
export { ForwardRef as ReactComponent };